import React from 'react';

import Forward from 'material-ui/svg-icons/content/forward';

import { SimpleForm } from 'components/form';
import { TextInput } from 'components/input';

import CreateBase  from './components/CreateBase'
import { groupCreateBackendPath } from './urls';

export const GroupCreate = (props) => (
    <CreateBase createBackendPath={groupCreateBackendPath} {...props}>
        <SimpleForm submitButtonLabel="Continue" submitButtonIcon={<Forward/>}>
            <TextInput source="name" label="Name" isRequired={true} />
        </SimpleForm>
    </CreateBase>
);


// WEBPACK FOOTER //
// ./src/routes/user/GroupCreate.js